// extracted by mini-css-extract-plugin
module.exports = {"root":"Placeholder_root__2xcIz","highlight":"Placeholder_highlight__3yW0Y"};